<template>
  <div style="width: 100%; height: 100%">
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline" style="padding-top:0; margin-top:0" label-suffix="：">
        <el-form-item label="日期">
          <el-date-picker v-model="searchForm.DATE" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd" :clearable="false">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button v-preventReClick @click="handleSearch" :loading="loadSearch">筛选</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-preventReClick @click="exportDialog = true">导出</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row v-loading="loadSearch">
      <el-col :span="24">
        <el-table :data="tableData" border stripe style="width: 100%" :span-method="objectSpanMethod" :cell-style="getCellStyle" show-summary>
          <el-table-column type="index" label="序号" width="45" min-width="30"></el-table-column>
          <el-table-column prop="PROJECT_NAME" label="项目点名称" min-width="100"></el-table-column>
          <el-table-column prop="DK_NAME" label="档⼝名称" min-width="100"></el-table-column>
          <el-table-column prop="INCOME_FEE" label="收入" min-width="80"></el-table-column>
          <el-table-column prop="DEDUCTION_POINT" label="扣点" min-width="80"></el-table-column>
          <el-table-column prop="COST_FEE" label="成本" min-width="80"></el-table-column>
          <el-table-column prop="PROFIT_AND_LOSS" label="盈亏" min-width="80"></el-table-column>
          <el-table-column prop="GROSS_PROFIT_RATE" label="利润比" min-width="80"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="exportDialog" @close="closeExportForm" title="导出利润分析" width="400px" center>
      <el-form ref="exportForm" :model="exportForm" label-suffix="：" label-width="auto">
        <el-form-item label="日期范围" prop="DATE_RANGE">
          <el-date-picker v-model="exportForm.DATE_RANGE" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="width: 100%;">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button v-preventReClick class="operate-btn" @click="closeExportForm">取消</el-button>
        <el-button v-preventReClick class="operate-btn" @click="handleExport">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>


import date, { 判断日期范围是否超过限制 } from '@/assets/common/date';
import http from '@/assets/common/http';

export default {

  data() {
    return {
      loadSearch: false,
      tableData: [],
      searchForm: {
        DATE: date(new Date(), '%F'),
      },
      exportForm: {
        DATE_RANGE: [],
      },
      exportDialog: false,
      spanArr: [],
      pos: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },

    };
  },
  created() {
    if (this.PROFIT_ANALYSIS_DATA_CONDITION.CONDITION) {
      this.searchForm = this.PROFIT_ANALYSIS_DATA_CONDITION.CONDITION;
    }
    this.handleSearch();
  },
  computed: {
    // 上一次的搜索结果和条件
    PROFIT_ANALYSIS_DATA_CONDITION() {
      return this.$store.state.PROFIT_ANALYSIS_DATA_CONDITION;
    },
  },
  methods: {
    closeExportForm() {
      this.$refs.exportForm.resetFields();
      this.exportDialog = false;
    },
    handleSearch() {
      const data = {
        SERVICE_ID: '10080',
        OTYPE: 5,
        SUPPLIER_ID: sessionStorage.getItem('tcId'),
        START_DAY: this.searchForm.DATE,
        END_DAY: this.searchForm.DATE,
      };
      this.loadSearch = true;
      http.post(data).then((result) => {
        if (result.length) {
          this.tableData = result.map((item) => ({ ...item, DEDUCTION_POINT: `${item.DEDUCTION_POINT}%` }));
          this.getSpanArr(this.tableData);
          this.$store.dispatch('SET_PROFIT_ANALYSIS_DATA_CONDITION', {
            CONDITION: this.searchForm,
            DATA: this.tableData,
          });
        }
        this.loadSearch = false;
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleExport() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs.exportForm.validate((valid) => {
            if (valid) {
              if (判断日期范围是否超过限制(...this.exportForm.DATE_RANGE)) {
                this.$message.show({ text: '日期范围不得大于一个月', type: 'warning' });
                document.body.style.cursor = 'default';
                return;
              }
              const params = {
                
                SERVICE_ID: '10080',
                OTYPE: 6,
                SUPPLIER_ID: sessionStorage.getItem('tcId'),
                START_DAY: this.exportForm.DATE_RANGE[0],
                END_DAY: this.exportForm.DATE_RANGE[1],
              };
              http.post(params).then((result) => {
                if (result[0]) window.open(this.$util.getURLLocalHost(result[0].FILE_PATH));
                document.body.style.cursor = 'default';
                this.closeExportForm();
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {}
      }
    },
    getSpanArr(data) {
      this.spanArr = [];
      this.pos = 0;
      data.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          if (data[index].PROJECT_ID == data[index - 1].PROJECT_ID) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = index;
          }
        }
      });
    },
    objectSpanMethod({ rowIndex, column }) {
      if (['PROJECT_NAME'].includes(column.property)) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      return false;
    },
    getCellStyle({ row, column }) {
      if (['PROJECT_NAME'].includes(column.property)) return {};

      const value = Number(row.GROSS_PROFIT_RATE.slice(0, -1));
      return (value > 25 || value < 15) ? { color: 'red' } : {};
    },
  },

};
</script>




// WEBPACK FOOTER //
// src/components/priceManagement/projectProfitAnalysis.vue